// extracted by mini-css-extract-plugin
export default {"fade":"message-box_fade__VDD5Y","fadeInAnimation":"message-box_fadeInAnimation__0Ej2o","contentImg":"message-box_contentImg__Rey0L","contentAudio":"message-box_contentAudio__F-v8Z"};